import type { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { WarningAltFilled } from '@mint-lib/icons';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

type Props = {
  isOpened: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

const DeleteApproverGroup: FC<Props> = ({ isOpened, onClose, onSubmit }) => {
  const { t } = useTranslation('@myn/approval_v2');

  return (
    <Dialog modal onOpenChange={onClose} open={isOpened}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="s" aria-describedby={undefined}>
          <DialogHeader>
            <DialogTitle className="flex flex-row items-center gap-1">
              <WarningAltFilled className="fill-error-main" />
              {t('Delete this approver group?')}
            </DialogTitle>
          </DialogHeader>
          <DialogContent>
            <p className={typographyVariants({ variant: 'bodyLong01' })}>
              {t(
                'If you proceed you will no longer be able to use this group anymore.',
              )}
            </p>
          </DialogContent>
          <DialogFooter>
            <Button
              size="large"
              variant="text"
              onClick={onClose}
              aria-label="Close the modal"
              data-dd-action-name="Close the modal"
            >
              {t('Cancel')}
            </Button>
            <Button
              size="large"
              aria-label="Confirm deleting the group"
              data-dd-action-name="Delete the group"
              onClick={onSubmit}
              color="error"
            >
              {t('Yes, delete')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};

export default DeleteApproverGroup;
